import { createApp } from 'vue'
import 'uno.css'
import './style.css'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { useUserAndCompanyInfosStore } from '@s/userAndCompanyInfo'
router.beforeEach(async (to, from) => {
  if (to.path === '/f') {
    const st = useUserAndCompanyInfosStore()
    await st.updateCompanyInfo()
  }
})
const pinia = createPinia()
const app = createApp(App)
app.use(router)
app.use(pinia)
app.mount('#app')
